import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
  authorized: false,
  permissionArr:[],
  propertyId:0,
  customerId:0,
  userName:"",
  invoiceListTab:1,
  userId:"",
  loading:false

}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialStateValue,
  reducers: {
    authenticate: (state) => {
      state.authorized = true
    },
    signout: (state) => {
      state.authorized = false
      state.permissionArr = null;
      state.propertyId = null
      state.customerId = null
      state.userName = null 
      state.userId = null
    },

    setUserDetails:(state,action)=>{
      // console.log(action.payload)
      state.permissionArr = [];
      state.permissionArr.push(action.payload?.Roles);
      state.propertyId = action.payload.PropertyId
      state.customerId = action.payload.CustomerId
      state.userName = action.payload.FirstName 
      state.userId = action.payload.UserId
    },
    setInvoiceListTab:(state,action)=>{
      state.invoiceListTab = action.payload
     
    },
    setLoading:(state,action)=>{
      state.loading = action.payload
     
    },
  
   

  },
})

export const { authenticate, signout,setUserDetails ,setInvoiceListTab,setLoading} = authSlice.actions

export default authSlice.reducer
